import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { Permissions } from '@core/constants/permissions';
import { ExportApi } from '@shared/export/export-api.service';
import { FundingApi } from '@shared/funding/funding-api.service';
import { Moneybar } from '@shared/funding/moneybar';
import { Moment } from 'moment/moment';

@Component({
  selector: 'app-moneybar-container',
  templateUrl: 'moneybar-container.component.html',
  styleUrls: ['moneybar-container.component.scss'],
  standalone: false,
})
export class MoneybarContainerComponent implements OnInit, OnChanges {
  @Input() beneficiaryGroupUuid!: string;
  @Input() timeTravelDate?: Moment | null;
  @Input() color: ThemePalette | 'grey' = 'primary';

  moneybarData!: Moneybar;
  readonly rolesToDownload = [Permissions.ROLE_LEVEL_60];

  constructor(
    private exportApi: ExportApi,
    private fundingApi: FundingApi,
  ) {}

  ngOnInit(): void {
    if (!this.beneficiaryGroupUuid) {
      this.reloadMoneybar();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    const beneficiaryGroupUuidChange = changes.beneficiaryGroupUuid;
    if (beneficiaryGroupUuidChange) {
      this.reloadMoneybar();
    }
  }

  reloadMoneybar(): void {
    if (this.beneficiaryGroupUuid) {
      if (this.timeTravelDate) {
        // tslint:disable-next-line:max-line-length
        this.fundingApi
          .getFundingForGroupAt(this.beneficiaryGroupUuid, this.timeTravelDate)
          .subscribe(result => (this.moneybarData = result));
      } else {
        this.fundingApi.getFundingForGroup(this.beneficiaryGroupUuid).subscribe(result => {
          this.moneybarData = result;
        });
      }
    } else {
      this.fundingApi.getCurrentFunding().subscribe(result => {
        this.moneybarData = result;
      });
    }
  }

  downloadDetails(): void {
    this.exportApi.moneybarCsv(this.moneybarData.beneficiaryGroup.uuid);
  }

  downloadDonations(): void {
    this.exportApi.donationsCsv(this.moneybarData.beneficiaryGroup.uuid);
  }
}
